/// <reference path="../typings/index.d.ts" />
/// <reference path="ContadorJustGage.d.ts" />

namespace App {
    export class ContadorJustGage implements IContadorJustGage {
        public inicializarCampo(seletorId: string, titulo: string, valorInicial: number, min: number, max: number): any {
            var gauge: any = new JustGage({
                id: seletorId,
                value: valorInicial,
                min: min,
                max: max,
                title: titulo,
                label: titulo,
                gaugeWidthScale: 0.4,
                customSectors: {
                    percents: true,
                    ranges: [{
                        color: "#00e673",
                        lo: 0,
                        hi: 50
                    }, {
                        color: "#ffff00",
                        lo: 51,
                        hi: 80
                    }, {
                        color: "#ff1a1a",
                        lo: 81,
                        hi: 100
                    }]
                }
            }
            );

            return gauge;
        }
    }
}
